// extracted by mini-css-extract-plugin
export default {"flex":"aV","imgwrap":"bV","image":"cV","textinfo":"eV","producttitle":"fV","bolder":"gV","block":"hV","info":"iV","moredetails":"jV","whitebox":"kV","old_price":"lV","discount":"mV"};
    if(module.hot) {
      // 1713969936498
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  